import PropTypes from 'prop-types';
const { arrayOf, node, oneOfType } = PropTypes;
import { Row, Col } from '@thd-olt-component-react/core-ui';
import React from 'react';
import { MobileAwareOverlay } from '../../../components/MobileAwareOverlay';

export function TextModal({ children, sections, onModalClose }) {
  const renderTextSection = ({ heading, text }) => {
    return (
      <div key={heading}>
        <Row>
          <Col>
            <b style={{ fontSize: '16px' }}>{heading}</b>
          </Col>
        </Row>
        <Row>
          <Col>
            <p style={{ fontSize: '14px' }}>{text}</p>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <MobileAwareOverlay
      modalClass="preferences-modal"
      onClose={onModalClose}
    >
      <Row className="preferences-modal__content">
        {sections.length ? <Col>{sections.map(renderTextSection)}</Col> : children}
      </Row>
    </MobileAwareOverlay>
  );
}

TextModal.defaultProps = {
  sections: [],
  children: null,
};

TextModal.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
  sections: arrayOf(PropTypes.shape({})),
  onModalClose: PropTypes.func.isRequired,
};
